module.exports = __webpack_public_path__ + "img/5.35ae7c6c.jpg";